import {
  getTableData,
  addTradeName,
  getInci,
  getManagementData,
  getDetail,
  getManagementDetail,
  approveTradeName,
  withdraw,
  getCount,
  getInciName,
  enableOperate,
  setKeyProduct,
  setSampleRequest,
  getUploadTradeCount,
  deleteDraft
} from '@/axios/api/BASFProduct.js'

const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const RESET_PARAMS = 'RESET_PARAMS'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_INCI = 'UPDATE_INCI'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_PREVIEW = 'UPDATE_PREVIEW'
const UPDATE_COUNT = 'UPDATE_COUNT'
const state = {
  tableData: [],
  count: 0,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    prd: '',
    tradeName: '',
    deliveryFormId: '',
    status: '',
    ecoStatus: '',
    mainGroupIds: '',
    functionId: '',
    approverId: '',
    createUserId: '',
    enable: '',
    keyProduct: '',
    showQdName: '',
    consumerBenefitId: '',
    sampleRequest: '',
    languageIds: []
  },
  inciList: [],
  detail: {},
  preview: {}
}

const getters = {
  tableData: state => state.tableData,
  pager: state => state.pager,
  params: state => state.params,
  inciList: state => state.inciList.map(v => {
    return {
      label: v.inciName,
      value: v.id || v.inciName
    }
  }),
  detail: state => state.detail,
  count: state => state.count,
  preview: state => state.preview
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_PARAMS] (state, params) {
    state.params = { ...state.params, params }
  },
  [RESET_PARAMS] (state, params) {
    state.params = {
      prd: '',
      tradeName: '',
      deliveryFormId: '',
      status: '',
      ecoStatus: '',
      mainGroupIds: '',
      functionId: '',
      approverId: '',
      createUserId: '',
      enable: '',
      keyProduct: '',
      showQdName: '',
      consumerBenefitId: '',
      sampleRequest: '',
      languageIds: []
    }
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = pager
    if (params) state.params = params
  },
  [UPDATE_INCI] (state, inciList) {
    state.inciList = inciList
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_COUNT] (state, count) {
    state.count = count
  },
  [UPDATE_PREVIEW] (state, preview) {
    state.preview = preview
  }
}

const actions = {
  // 获取my data upload列表
  async getTableDataApi ({ commit }, params) {
    try {
      let { data: res } = await getTableData(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {}
  },
  // 获取data management列表
  async getManagementApi ({ commit }, params) {
    try {
      let { data: res } = await getManagementData(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {}
  },
  // 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 设置参数
  setParams ({ commit }, params) {
    commit(UPDATE_PARAMS, params)
  },
  // 清空参数
  clearParamsApi ({ commit }, pager) {
    const params = {
      prd: '',
      tradeName: '',
      deliveryFormId: '',
      status: '',
      ecoStatus: '',
      mainGroupIds: '',
      functionId: '',
      approverId: '',
      createUserId: '',
      enable: '',
      keyProduct: '',
      showQdName: '',
      consumerBenefitId: '',
      sampleRequest: '',
      languageIds: []
    }
    commit(UPDATE_SEARCH, { pager, params })
  },
  // 新增编辑
  async addTradeName ({ commit }, params) {
    try {
      const { data: res } = await addTradeName(params)
      return res || true
    } catch (e) {
      return false
    }
  },
  // 获取inci下拉
  async getInciApi ({ commit }, params) {
    try {
      let { data: res } = await getInci(params)
      commit(UPDATE_INCI, res)
      return true
    } catch (e) {
      return false
    }
  },
  // 获取详情
  async getDetailApi ({ commit }, params) {
    try {
      let { data: res } = await getDetail(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
  },
  // 获取详情
  async getManagementDetailApi ({ commit }, params) {
    try {
      let { data: res } = await getManagementDetail(params)
      commit(UPDATE_DETAIL, res)
      return res
    } catch (e) {}
  },
  // 获取预览
  async getPreviewApi ({ commit }, params) {
    try {
      let { data: res } = await getDetail(params)
      commit(UPDATE_PREVIEW, res)
    } catch (e) {}
  },
  // 审批
  async approveApi ({ commit }, params) {
    try {
      await approveTradeName(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 撤回
  async withdrawApi ({ commit }, params) {
    try {
      await withdraw(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 获取count
  async getCountApi ({ commit }, params) {
    try {
      const { data: res } = await getCount(params)
      commit(UPDATE_COUNT, res)
    } catch (e) {
    }
  },
  // 获取inciName
  async getInciNameApi ({ commit }, params) {
    try {
      const { data: res } = await getInciName(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 禁用/启用
  async enableOperateApi ({ commit }, params) {
    try {
      await enableOperate(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 设置 Key focus product
  async setKeyProductApi ({ commit }, params) {
    try {
      const res = await setKeyProduct(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 设置Sample Request
  async setSampleRequestApi ({ commit }, params) {
    try {
      const res = await setSampleRequest(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getUploadTradeCountApi ({ commit }, params) {
    try {
      const res = await getUploadTradeCount(params)
      return res
    } catch (e) {
      return false
    }
  },
  async deleteDraftApi ({ commit }, params) {
    try {
      const res = await deleteDraft(params)
      return res && res.errorCode === 200
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/basfproduct.js